module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [(_vm.fill_info == '') ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "nev",
      "label": "Név",
      "name": "nev",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ,]+",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.nev),
      callback: function($$v) {
        _vm.form.nev = $$v
      },
      expression: "form.nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "email",
      "label": "E-mail cím",
      "name": "email",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "kutatas_cime",
      "label": "Kutatás címe",
      "name": "kutatas_cime",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.kutatas_cime),
      callback: function($$v) {
        _vm.form.kutatas_cime = $$v
      },
      expression: "form.kutatas_cime"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "temavezeto_neve",
      "label": "Témavezető neve",
      "name": "temavezeto_neve",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.temavezeto_neve),
      callback: function($$v) {
        _vm.form.temavezeto_neve = $$v
      },
      expression: "form.temavezeto_neve"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": ".ppt,.pptx,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "errors": _vm.errors,
      "id": "ppt_file",
      "label": "Konferencia előadás (Power Point, 16:9)",
      "name": "ppt_file",
      "loaded_files": _vm.form.ppt_file
    },
    on: {
      "change": function (value) {
        _vm.form.ppt_file = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._l((_vm.form.kulso_urlek), function(url, i) {
    return _c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "margin-bottom": "5px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.kulso_urlek[i]),
        expression: "form.kulso_urlek[i]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Külső Url (pl.: http://webcim.hu/dokumentum.ppt)"
      },
      domProps: {
        "value": (_vm.form.kulso_urlek[i])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.form.kulso_urlek,
            $$idx = i;
          if (!Array.isArray($$exp)) {
            _vm.form.kulso_urlek[i] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "button only-icon v2",
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "href": _vm.form.kulso_urlek[i],
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _vm._v(" "), _c('button', {
      staticClass: "button only-icon",
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteUrl(i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "margin-bottom": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uj_kulso_url),
      expression: "uj_kulso_url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Külső Url (pl.: http://webcim.hu/dokumentum.ppt)"
    },
    domProps: {
      "value": (_vm.uj_kulso_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.uj_kulso_url = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button only-icon v2",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.saving,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.save(0)
      }
    }
  }, [_vm._v("Mentés")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.saving,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.save(1)
      }
    }
  }, [_vm._v("Véglegesít")])])])]) : _vm._e(), _vm._v(" "), (_vm.fill_info != '') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("ÚNKP Konferencia")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.fill_info)
    }
  })])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("ÚNKP Konferencia")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35dbbf44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/unkp_konferencia_23.vue
// module id = 354
// module chunks = 0